import Frame from '../frame/Frame';
import { scenarioState } from '../../stores/scenarioState';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import Debug from '../Debug';
import React, { useCallback, useEffect } from 'react';
import { FormValues } from "../../stores/formState";
import { completedFormState } from '../../stores/completedFormState';

interface WebInterviewProps {
  onCompleted: (form: FormValues) => void;
}

const WebInterviewInner = (props: WebInterviewProps) => {
  const form = useRecoilValueLoadable(completedFormState);
  const scenario = useRecoilValue(scenarioState);

  const onCompleted = props.onCompleted;
  const doComplete = useCallback((form: FormValues) => {
    onCompleted(form)
  }, [onCompleted]);

  const state = form.state;
  const formValue = form.contents;
  useEffect(() => {
    if (state !== 'hasValue') return;
    if (formValue == null) return;

    doComplete(formValue);
  }, [state, formValue, doComplete]);

  return ( <Frame param={scenario} color={scenario.body.color}/>);

}

const WebInterview = (props: WebInterviewProps) => {
  return (<>
      <WebInterviewInner {...props}/>
      <React.Suspense fallback={"..."}><Debug/></React.Suspense>
    </>
  );
}

export default WebInterview;
